import { DataTable, DataTableHeader, DataTableHeaderCell, DataTableBody } from "~/react/ui/data-table"
import { Skeleton } from "~/react/ui/skeleton"
import { Checkbox } from "~/react/ui/checkbox"

type SkeletonColumn = {
  label: React.ReactNode
  sticky?: boolean
}

type DataTableSkeletonProps = {
  columns: SkeletonColumn[]
  checkboxAriaLabel: string
  rows?: number
}

export function DataTableSkeleton({ columns, checkboxAriaLabel, rows = 5 }: DataTableSkeletonProps) {
  // Derive columnCount from columns.length + 1 (for the actions column)
  const columnCount = columns.length + 1
  return (
    <DataTable>
      <DataTableHeader>
        <DataTableHeaderCell className="h-data-table__checkbox">
          <div className="h-data-table-cell h-data-table-cell--checkbox">
            <Checkbox aria-label={checkboxAriaLabel} />
          </div>
        </DataTableHeaderCell>

        {columns.map((column, index) => (
          <DataTableHeaderCell key={index} sticky={column.sticky}>
            {column.label}
          </DataTableHeaderCell>
        ))}

        <DataTableHeaderCell />
      </DataTableHeader>

      <DataTableBody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <tr key={rowIndex} data-skeleton="true">
            <td className="h-data-table__checkbox">
              <Skeleton
                className="h-data-table-cell h-data-table-cell--skeleton-checkbox"
                aria-label={i18n.t("js.data_table.loading")}
                noAnimate
              />
            </td>
            {Array.from({ length: columnCount }).map((_, colIndex) => (
              <td key={colIndex}>
                <Skeleton
                  className="h-data-table-cell h-data-table-cell--skeleton"
                  aria-label={i18n.t("js.data_table.loading")}
                  noAnimate
                />
              </td>
            ))}
          </tr>
        ))}
      </DataTableBody>
    </DataTable>
  )
}
